import TraditionalComparison from "@/components/comparisonWithTraditional";
import { COMPARISON_CONSTANTS } from "./constants";

const ComparisonComp = () => {
  return <TraditionalComparison {...COMPARISON_CONSTANTS} />;
};

export default ComparisonComp;
